import { minsidePage, postPage, eiendomPage, fakturaPage, formsPage, servicesPage, nationalServicesPage } from "#templates/pages/minside/minside_template";

export const minside = () => {
	const pageColor = window.serverdata.configMeta.aim.style?.minside?.page__color || "var(--primary__color-200)";
	const urlParams = new URLSearchParams(window.location.search);
	const pageParam = urlParams.get("page");

	switch (pageParam) {
		case "post":
			return postPage({
				pageColor,
				user: { displayname: localStorage.getItem("access_pid") },
			});
		case "eiendom":
			return eiendomPage({
				pageColor,
				user: { displayname: localStorage.getItem("access_pid") },
			});
		case "tjenester":
			return servicesPage({
				pageColor,
				user: { displayname: localStorage.getItem("access_pid") },
			});
		case "nasjonale-tjenester":
			return nationalServicesPage({
				pageColor,
				user: { displayname: localStorage.getItem("access_pid") },
			});
		case "faktura":
			return fakturaPage({
				pageColor,
				user: { displayname: localStorage.getItem("access_pid") },
			});
		case "forms":
			return formsPage({
				pageColor,
				user: { displayname: localStorage.getItem("access_pid") },
			});
		default:
			return minsidePage({
				pageColor,
				user: { displayname: localStorage.getItem("access_pid") },
			});
	}
};
